module.exports = __webpack_public_path__ + "img/Font 22.c7daa8e0.jpg";